import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NotFound from './Screens/NotFound';
import { GlobalStorage } from './GlobalContext';
import FacilitiesHome from './Screens/Facilities/FacilitiesHome';
import FacilitiesCardapio from './Screens/Facilities/FacilitiesCardapio';
import CardapioItem from './Screens/Facilities/CardapioItem';
import Carrinho from './Screens/Facilities/Carrinho';
import Concierge from './Screens/Facilities/Concierge';
import Diretorio from './Screens/Facilities/Diretorio';
import { Extrato } from './Screens/Facilities/Extrato';
import TipoRefeicao from './Screens/Facilities/TipoRefeicao';
import Sucesso from './Screens/Facilities/Sucesso';

const Rotas = () => {
  return (
    <Routes>
      <Route path="/:cliente_id/:partner_id/*" element={<FacilitiesHome />} />
      <Route path="/:cliente_id/*" element={<FacilitiesHome />} />
      <Route path="/:cliente_id/global" element={<GlobalStorage />} />
      <Route path="/:cliente_id/cardapio/*" element={<FacilitiesCardapio />} />
      <Route
        path="/:cliente_id/cardapio/:tipo_id/*"
        element={<FacilitiesCardapio />}
      />
      <Route path="/:cliente_id/cardapio/tipo/*" element={<TipoRefeicao />} />
      <Route
        path="/:cliente_id/cardapioitem/:item_id"
        element={<CardapioItem />}
      />
      <Route path="/carrinho" element={<Carrinho />} />
      <Route path="/:cliente_id/carrinho/*" element={<Carrinho />} />
      <Route path="/:cliente_id/concierge" element={<Concierge />} />
      <Route path="/:cliente_id/diretorio" element={<Diretorio />} />
      <Route path="/:cliente_id/extrato" element={<Extrato />} />
      <Route path="/:cliente_id/sucesso/*" element={<Sucesso />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Rotas;
